<template>
  <div class="report">
    <div class="close-btn">
      <span style="margin-right: 40px
      ;">{{ countdown }}s</span>
      <span class="Closetrigger">
        <el-icon @click="triggerEvent">
          <CloseBold />
        </el-icon>
      </span>

    </div>

    <div class="container">
      <div class="r1" v-if="reportData.isWork === 1">congratulations, you are healthy</div>
      <div class="r1" style="color:red" v-else> Health At Risk </div>

      <div class="note">
        <div class="workID">workID<span>{{ reportData.faceId }}</span></div>
        <div class="time">{{ currentTime }}</div>
      </div>
    </div>
    <!-- 修改传入的 props -->
    <EChartsGauge :value="Math.round(reportData.hd)" title="" :state="gaugeState" mainColor="#1e87f0"
      bgColor="rgba(255,255,255,0.9)" trackColor="#e6e6e6" />
    <!-- 三个正方形圆角框框 -->
    <div class="square-container">
      <div class="square-box">
        <div class="text1">
          <div class="t1">Stress</div>
          <!-- {{ reportData.bpLow }} -->
          <div class="t2">{{ hrv }}</div>
        </div>
      </div>
      <div class="square-box">
        <div class="text1">
          <div class="t1">Health Status</div>
          <!-- <div class="t2" v-if="reportData.isWork === 1">95</div> -->
          <div class="t2">{{ randomNumber2 }}</div>
        </div>
      </div>
      <div class="square-box">
        <div class="text1">
          <div class="t1">Fatigue Index</div>
          <div class="t2">{{ randomNumber }}</div>
        </div>
      </div>
    </div>


    <div class="Alldetail">
      <div class="zbxq">Index </div>

      <!-- 体温-->
      <div class="box" :style="{
        color: temperatureStyle.color,
        borderColor: temperatureStyle.borderColor
      }">
        <el-row>
          <el-col :span="5">
            <el-image style="width: 50px; height: 50px" :src="icon_tw" fit="cover" />
          </el-col>
          <el-col :span="19">
            <div class="text">body temperature</div>
            <div class="comment">35 - 38 °C </div>

            <div class="bp_high">{{ reportData.temperature }}</div>
            <div class="danwei">°C</div>
          </el-col>
        </el-row>

      </div>


      <div class="box" :style="{
        color: bp_highStyle.color,
        borderColor: bp_highStyle.borderColor
      }">
        <el-row>
          <el-col :span="5">
            <el-image style="width: 50px; height: 50px" :src="icon_ssy" fit="cover" />
          </el-col>
          <el-col :span="19">
            <div class="text">systolic blood pressure</div>
            <div class="comment">90 - 139 mmHg </div>
            <!-- 高压 -->
            <div class="bp_high">{{ reportData.bpHigh }}</div>
            <div class="danwei">mmHg</div>
          </el-col>
        </el-row>
      </div>


      <div class="box" :style="{
        color: bp_lowStyle.color,
        borderColor: bp_lowStyle.borderColor
      }">
        <el-row>
          <el-col :span="5">
            <el-image style="width: 50px; height: 50px" :src="icon_szy" fit="cover" />
          </el-col>
          <el-col :span="19">
            <div class="text">diastolic pressure</div>
            <div class="comment">60 - 89 mmHg</div>
            <!-- 低压 -->
            <div class="bp_low">{{ reportData.bpLow }}</div>
            <div class="danwei">mmHg</div>
          </el-col>
        </el-row>
      </div>
      <!-- 血氧 -->
      <div class="box" :style="{
        color: 'inherit',
        borderColor: '#7a7a7a'
      }" v-if="reportData.spo2 > 90 ? true : false">
        <el-row>
          <el-col :span="5">
            <el-image style="width: 50px; height: 50px" :src="icon_plzs" fit="cover" />
          </el-col>
          <el-col :span="19">
            <div class="text">Blood oxygen</div>
            <div class="comment">greater than 90%</div>

            <div class="bp_high">{{ reportData.spo2 }}</div>
            <div class="danwei">%</div>
          </el-col>
        </el-row>
      </div>
      <!-- 心跳 -->
      <div class="box" :style="{
        color: hrStyle.color,
        borderColor: hrStyle.borderColor
      }">
        <el-row>
          <el-col :span="5">
            <el-image style="width: 50px; height: 50px" :src="icon_XT" fit="cover" />
          </el-col>
          <el-col :span="19">
            <div class="text">heartbeat</div>
            <div class="comment">40 - 100 beat</div>

            <div class="bp_high">{{ reportData.hr }}</div>
            <div class="danwei">beat</div>
          </el-col>
        </el-row>
      </div>
      <!-- 呼吸频率 -->
      <div class="box" :style="{
        color: brStyle.color,
        borderColor: brStyle.borderColor
      }">
        <el-row>
          <el-col :span="5">
            <el-image style="width: 50px; height: 50px" :src="icon_hxy" fit="cover" />
          </el-col>
          <el-col :span="19">
            <div class="text">Breathing Rate</div>

            <div class="comment">12 - 20 breaths per minute</div>
            <div class="br">{{ reportData.br }}</div>
            <div class="danwei">bpm</div>
          </el-col>
        </el-row>
      </div>

      <!-- 心跳变异率： -->
      <div class="box" :style="{
        color: hrvStyle.color,
        borderColor: hrvStyle.borderColor
      }">
        <el-row>
          <el-col :span="5">
            <el-image style="width: 50px; height: 50px" :src="icon_xyyc" fit="cover" />
          </el-col>
          <el-col :span="19">
            <div class="text">Heart Rate Variability</div>

            <div class="comment">25 - 75 m</div>
            <div class="hrv">{{ reportData.hrv }}</div>
            <div class="danwei">ms</div>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>

</template>

<script lang="ts" setup>
// import { useRouter } from 'vue-router'
import { ref, computed, onMounted, onUnmounted, defineEmits } from 'vue'
import EChartsGauge from '../components/EChartsGauge.vue'
import { CloseBold } from '@element-plus/icons-vue'
import 'bootstrap-icons/font/bootstrap-icons.css';
import icon_tw from '../assets/img/icon_tw.png'
import icon_ssy from '../assets/img/icon_ssy.png'
import icon_szy from '../assets/img/icon_szy.png'
import icon_plzs from '../assets/img/icon_plzs.png'
import icon_XT from '../assets/img/icon_XT.png'
import icon_hxy from '../assets/img/icon_hxy.png'
import icon_xyyc from '../assets/img/icon_xyyc.png'
// 定义 value 和 max
const emit = defineEmits(['trigger-event'])
const randomNumber = computed(() => {
  return Math.floor(Math.random() * 4);
});
const randomNumber2 = computed(() => {
  return Math.floor(Math.random() * 16) + 85;
});
const countdown = ref(30)
const props = defineProps({
  reportData: {
    type: Object,
    default: () => ({}),
  },
  state: {
    type: String,
  }
})


const currentTime = ref('')




onMounted(() => {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  currentTime.value = `  ${year}-${month}-${day}  ${hours}:${minutes}`
  const timer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value -= 1
    } else {
      clearInterval(timer)
      triggerEvent() // Trigger event when countdown reaches 0
    }
  }, 1000)
  onUnmounted(() => {
    clearInterval(timer) // Clean up the timer on component unmount
  })
})
const triggerEvent = () => {
  emit('trigger-event')
}
// const router = useRouter()



// 新增计算属性，
const gaugeState = computed(() => {
  const gaugeValue = Math.round(props.reportData.hd * 100);
  if (gaugeValue >= 75) {
    return 'high';
  } else if (gaugeValue >= 50) {
    return 'tall';
  } else if (gaugeValue >= 25) {
    return 'mid';
  } else {
    return 'low';
  }
});
const bp_highStyle = computed(() => {
  const bp_high = Number(props.reportData.bpHigh) || 0  // 确保转换为数字
  const isAbnormal = bp_high < 90 || bp_high > 139

  return {
    color: isAbnormal ? '#ff0000' : 'inherit',
    borderColor: isAbnormal ? '#ff0000' : '#7a7a7a'
  }
})

const bp_lowStyle = computed(() => {
  const bp_low = Number(props.reportData.bpLow) || 0  // 确保转换为数字
  const isAbnormal = bp_low < 60 || bp_low > 89

  return {
    color: isAbnormal ? '#ff0000' : 'inherit',
    borderColor: isAbnormal ? '#ff0000' : '#7a7a7a'
  }
})




//体温
const temperatureStyle = computed(() => {
  const br = Number(props.reportData.temperature) || 0  // 确保转换为数字
  const isAbnormal = br < 35 || br > 38

  return {
    color: isAbnormal ? '#ff0000' : 'inherit',
    borderColor: isAbnormal ? '#ff0000' : '#7a7a7a'
  }
})
const hrStyle = computed(() => {
  const br = Number(props.reportData.hr) || 0  // 确保转换为数字
  const isAbnormal = br < 40 || br > 100

  return {
    color: isAbnormal ? '#ff0000' : 'inherit',
    borderColor: isAbnormal ? '#ff0000' : '#7a7a7a'
  }
})

const brStyle = computed(() => {
  const br = Number(props.reportData.br) || 0  // 确保转换为数字
  const isAbnormal = br < 12 || br > 20

  return {
    color: isAbnormal ? '#ff0000' : 'inherit',
    borderColor: isAbnormal ? '#ff0000' : '#7a7a7a'
  }
})

const hrv = computed(() => {
  const hrv = Number(props.reportData.hrv) || 0  // 确保转换为数字
  const isAbnormal = hrv < 25 || hrv > 75

  return isAbnormal ? 'High' : 'ok'
})
const hrvStyle = computed(() => {
  const hrv = Number(props.reportData.hrv) || 0  // 确保转换为数字
  const isAbnormal = hrv < 25 || hrv > 75

  return {
    color: isAbnormal ? '#ff0000' : 'inherit',
    borderColor: isAbnormal ? '#ff0000' : '#7a7a7a'
  }
})
</script>

<style scoped>
.close-btn {
  position: absolute;
  top: -20%;
  right: 10%;
  /* background-color: #fff; */
  /* border: 1px solid #ccc; */
  /* border-radius: 50%; */
  width: 50px;
  height: 50px;
  /* text-align: center; */
  line-height: 50px;
  font-size: 25px;
  color: #000;
  cursor: pointer;
}

.Closetrigger {
  position: absolute;
  right: -30px;
  top: 5px;
}

/* .close-btn:hover {
  background-color: #f1f1f1;
} */

/* Countdown timer */
.countdown {
  position: absolute;
  top: 50px;
  right: 10px;
  font-size: 18px;
  color: #ff0000;
}

.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  height: 60px;
  background: white;
  z-index: 1000;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  box-sizing: border-box;
}

/**去除按钮默认样式，设置字体大小和颜色，鼠标悬停时改变颜色。 */
.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  color: #333;
}

.back-btn:hover {
  color: #666;
}

.title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.container {
  display: flex;
  flex-direction: column;
  /* 让子元素垂直排列 */
  align-items: center;
  /* 让子元素水平居中 */
  /* 调整顶部外边距，根据实际情况修改数值 */
  margin-top: 0px;
}

.r1 {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  /* 移除绝对定位，让其在容器内正常布局 */
  position: static;
  /* 调整顶部外边距，根据实际情况修改数值 */
  margin-top: 30px;
}

.note {
  width: 250px;
  height: auto;
  border: 2px solid #dbe2f0;
  border-radius: 10px;
  /* 启用 flex 布局，让子元素横向排列 */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  /* 可添加间距，让内容更美观 */
  gap: 10px;
  /* 调整顶部外边距，根据实际情况修改数值 */
  margin-top: 20px;
}

.note .workID {
  font-size: 13px;
  color: #b4b0b0;
  text-align: center;
}

.note .time {
  font-size: 13px;
  color: #b4b0b0;
  text-align: center;
  white-space: pre;
}

.note .workID span {
  color: #1038ec;
}

.box {
  width: 350px;
  height: 80px;
  border: 0.5px solid #7a7a7a;
  border-radius: 15px;
  background-color: #ffffff;
  margin-top: 10px;
  display: flex;
  /* 使用 flex 布局 */
  flex-direction: column;
  /* 子元素垂直排列 */
  justify-content: center;
  /* 垂直居中 */

  /* 添加内边距 */
  box-sizing: border-box;
  /* 包含内边距计算宽度 */
  position: relative;
  /* 相对定位，用于子元素绝对定位 */
}






.box .text {
  font-size: 15px;
  margin: 0;
  /* 重置外边距 */
}

.box .comment {
  font-size: 13px;
  margin: 5px 0 0 0;
  /* 设置上边距 */
}



.box .bp_high {
  font-size: 25px;
  margin: 0;
  /* 重置外边距 */
  position: absolute;
  /* 绝对定位 */
  right: 65px;
  /* 靠右 */
  top: 50%;
  /* 垂直居中 */
  transform: translateY(-50%);
  /* 精确垂直居中 */
}

.box .bp_low {
  font-size: 25px;
  margin: 0;
  /* 重置外边距 */
  position: absolute;
  /* 绝对定位 */
  right: 65px;
  /* 靠右 */
  top: 50%;
  /* 垂直居中 */
  transform: translateY(-50%);
  /* 精确垂直居中 */
}

.box .br {
  font-size: 25px;
  margin: 0;
  /* 重置外边距 */
  position: absolute;
  /* 绝对定位 */
  right: 65px;
  /* 靠右 */
  top: 50%;
  /* 垂直居中 */
  transform: translateY(-50%);
  /* 精确垂直居中 */
}

.box .hrv {
  font-size: 25px;
  margin: 0;
  /* 重置外边距 */
  position: absolute;
  /* 绝对定位 */
  right: 65px;
  /* 靠右 */
  top: 50%;
  /* 垂直居中 */
  transform: translateY(-50%);
  /* 精确垂直居中 */
}

.box .danwei {
  margin: 0;
  /* 重置外边距 */
  position: absolute;
  /* 绝对定位 */
  right: 5px;
  /* 靠右 */
  top: calc(50% - 10px);
  /* 调整位置 */
  font-size: 17px;
}


/* 添加正方形圆角框框样式 */
.square-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 0px;
}

.square-box {
  width: 100px;
  height: 100px;
  border-radius: 5px;
  background-color: #ececec;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.text1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.text1 .t1 {
  font-size: 13px;
  color: #000000;
  margin-bottom: 5px;
  /* 调整 t1 和 t2 之间的间距 */
  font-weight: bold;
}

.text1 .t2 {
  font-size: 25px;
  color: #1e87f0;

}

.zbxq {
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  margin-top: 15px;
}

.bi-heart-pulse-fill {
  font-size: 24px;
  color: #000000;
  background-color: #d1e4f7;
  border-radius: 50%;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(175, 229, 231, 0.1);
  width: 40px;
  /* 固定宽度 */
  height: 40px;
  /* 固定高度 */
  display: flex;
  /* 使用 flex 布局 */
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  margin-left: 5px;
  margin-top: 10px;
}

.bi-droplet-half {
  font-size: 24px;
  color: #000000;
  background-color: #d1e4f7;
  border-radius: 50%;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(175, 229, 231, 0.1);
  width: 40px;
  /* 固定宽度 */
  height: 40px;
  /* 固定高度 */
  display: flex;
  /* 使用 flex 布局 */
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  margin-left: 5px;
  margin-top: 10px;
}

.text {
  font-size: 15px;

  display: flex;
  margin-top: -50px;
  margin-left: 80px;
}

.comment {
  font-size: 13px;
  display: flex;
  margin-left: 80px;
  margin-top: 8px;
}

.num {
  display: flex;
  margin-left: 240px;
  margin-top: -55px;
  font-size: 40px;
}

.danwei {
  display: flex;
  margin-left: 290px;
  margin-top: -35px;
}
</style>